import { Card } from '@/components/shadcn/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/shadcn/table';
import type { BadmintonStandingItem } from '@/services/badmintonService';
import { formatPointPair, formatSetPair, formatWinRatePercent } from './badmintonUiUtils';

interface BadmintonStandingsTableProps {
  standings: BadmintonStandingItem[];
}

function rankClass(position: number): string {
  return position <= 3 ? 'text-[#FC480D]' : 'text-gray-400';
}

export default function BadmintonStandingsTable({ standings }: BadmintonStandingsTableProps) {
  return (
    <Card className="overflow-hidden rounded-2xl border-0 bg-white shadow-[inset_0_0_0_1px_#E0E6ED]">
      <Table>
        <TableHeader>
          <TableRow className="border-0 hover:bg-transparent">
            <TableHead className="h-9 w-8 px-3 text-[10px] font-semibold uppercase tracking-wide text-gray-400" />
            <TableHead className="h-9 px-1 text-[10px] font-semibold uppercase tracking-wide text-gray-400">
              Pemain
            </TableHead>
            <TableHead className="h-9 w-8 px-1 text-center text-[10px] font-semibold uppercase tracking-wide text-gray-400">
              M
            </TableHead>
            <TableHead className="h-9 w-12 px-1 text-center text-[10px] font-semibold uppercase tracking-wide text-gray-400">
              WR
            </TableHead>
            <TableHead className="h-9 w-12 px-1 text-center text-[10px] font-semibold uppercase tracking-wide text-gray-400">
              Set
            </TableHead>
            <TableHead className="h-9 w-[4.5rem] px-3 text-right text-[10px] font-semibold uppercase tracking-wide text-gray-400">
              Poin
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {standings.length === 0 ? (
            <TableRow className="hover:bg-transparent">
              <TableCell colSpan={6} className="px-4 py-8 text-center text-sm text-gray-400">
                Belum ada data klasemen
              </TableCell>
            </TableRow>
          ) : (
            standings.map((row) => {
              const hasPoints = (row.pointsScored ?? 0) > 0 || (row.pointsConceded ?? 0) > 0;
              const gamesPlayed = hasPoints ? row.gamesPlayed : 0;
              const winRate = hasPoints ? row.winRate : 0;
              const setsWon = hasPoints ? (row.setsWon ?? 0) : 0;
              const setsLost = hasPoints ? (row.setsLost ?? 0) : 0;

              return (
                <TableRow key={row.participantId} className="border-gray-50 hover:bg-transparent">
                  <TableCell className={`px-3 py-3 text-sm font-extrabold ${rankClass(row.position)}`}>
                    {row.position}
                  </TableCell>
                  <TableCell className="truncate px-1 py-3 text-sm font-extrabold text-[#0E1726]">
                    {row.playerName}
                  </TableCell>
                  <TableCell className="px-1 py-3 text-center text-sm text-[#0E1726]">
                    {gamesPlayed}
                  </TableCell>
                  <TableCell className="px-1 py-3 text-center text-sm text-[#0E1726]">
                    {formatWinRatePercent(winRate)}
                  </TableCell>
                  <TableCell className="px-1 py-3 text-center text-sm text-[#0E1726]">
                    {formatSetPair(setsWon, setsLost)}
                  </TableCell>
                  <TableCell className="px-3 py-3 text-right text-sm text-[#0E1726]">
                    {formatPointPair(row.pointsScored, row.pointsConceded)}
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </Card>
  );
}
